// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-CheckBox-CheckBox-module__container-USsp70","active":"src-app-components-forms-CheckBox-CheckBox-module__active-HfoMkn","readonly":"src-app-components-forms-CheckBox-CheckBox-module__readonly-kQd2fU","noMargin":"src-app-components-forms-CheckBox-CheckBox-module__noMargin-CojyvV"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-CheckBox-CheckBox-module__container-USsp70\",\"active\":\"src-app-components-forms-CheckBox-CheckBox-module__active-HfoMkn\",\"readonly\":\"src-app-components-forms-CheckBox-CheckBox-module__readonly-kQd2fU\",\"noMargin\":\"src-app-components-forms-CheckBox-CheckBox-module__noMargin-CojyvV\"}";
        // 1789362522822
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  